import axios from "axios";
import { BASE_URL_API_PANEL} from "../CONSTANTS";
import {store} from "../redux/store";
const _pHttp = axios.create();
_pHttp.defaults.baseURL =BASE_URL_API_PANEL;



//
_pHttp.interceptors.request.use(
    function(config) {
        // Add authorization token to the request headers
        //@ts-ignore
        const authToken =store.getState().auth.user.token

        config.headers.Authorization = `Bearer ${authToken}`;
        return config;
    },
    function(error) {
        // Handle request error
        return Promise.reject(error);
    }
);

export {_pHttp}
